import React from "react";
import { Button, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

export default function BulkUploadBlock({
    title,
    templateEnum,
    downloadFileName,
    getUploadProps,
    downloadExcelTemplate,
}) {
    return (
        <div className="bulk-upload-component">
            <div className="config-heading bulk-header">{title}</div>
            <div>
                <div className="configureFormRow">
                    <div className="configureFormCol">Upload excel template file</div>
                    <div className="configureFormCol">
                        <div className="configureFieldRow">
                            <div className="configureFieldCol">
                                <Dragger {...getUploadProps(templateEnum)} className="dropbox">
                                    <div className="box-content">
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">
                                            Click or drag file to this area to upload
                                        </p>
                                    </div>
                                </Dragger>
                            </div>
                        </div>
                        <div className="configureFieldRow">
                            <div className="configureFieldCol">
                                <div className="form-btn-container">
                                    <Button
                                        className="saveBtn redBtn"
                                        style={{ height: "40px", margin: "20px 0 0" }}
                                        onClick={() => downloadExcelTemplate(templateEnum, downloadFileName)}
                                    >
                                        Download template
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
